<div class="tags-wrap">
  <ng-container *ngFor="let tag of tags">
    <div class="tag">
      {{ 'tags.'+formatTagsKey(tag.name) | translate }}
    </div>
  </ng-container>
</div>
